// extracted by mini-css-extract-plugin
module.exports = {"controls":"VehicleCollision-hashed__controls__2o6Qw","car__wrapper":"VehicleCollision-hashed__car__wrapper__UFDlG"};